// eslint-disable-next-line
///<reference path="../../../../../../jsdoc-types.js" />

import { getPageUrl } from '../productSearch';

/**
 * Product search mixin new props
 * @typedef {object} ProductSearchMixin
 * @property {function():object} getNextPageCategory - Returns the category of the next url
 * @property {function():string} getNextPageUrl - returns the url of the next page
 * @property {function():string} getPreviousPageUrl - returns the url of the previous page
 * @property {function():boolean} isFirstPage - returns true if the given page number is the first one
 * @property {function():boolean} isLastPage - returns true if the given page number is the last
 */

/**
 * Extended product search
 * @typedef {ProductSearch | ProductSearchMixin} InfiniteProductSearch
 */

const infiniteProductSearchMixin =
  (paginationStrategy) =>
  /**
   * Helper factory
   * @param {ProductSearch} productSearch - SFRA's productSearch object
   * @param {import('./strategies/createPaginationStrategy').PaginationStrategy} paginationStrategy - strategy used for infinite scroll
   * @returns {InfiniteProductSearch} helper
   */
  (productSearch) => {
    if (!productSearch || Object.keys(productSearch).length === 0) {
      // Do not apply the mixin if the productSearch has no values. Probably after
      // a reset
      return null;
    }

    return {
      ...productSearch,
      /**
       * Returns the category of the next url
       * @returns {Object} - Category object
       */
      getNextPageCategory() {
        return paginationStrategy.getNextPageCategory(this);
      },

      /**
       * Returns the url of the next page
       * @returns {string} - url
       */
      getNextPageUrl() {
        return paginationStrategy.getNextPageUrl(this);
      },
      /**
       * Returns the url of the previous page
       * @returns {string} - url
       */
      getPreviousPageUrl() {
        if (this.isFirstPage()) return null;
        return getPageUrl(this, this.pageNumber - 1);
      },
      /**
       * Returns true if the given page number is the first one
       * @returns {boolean} - true if it is the first page
       */
      isFirstPage() {
        return this.pageNumber === 0;
      },

      /**
       * Returns true if the given page number is the last
       * @returns {boolean} - true if it is the last page
       */
      isLastPage() {
        return paginationStrategy.isLastPage(this);
      },
    };
  };

export default infiniteProductSearchMixin;
